const getInitialState = () => {
  const table_size = localStorage.getItem('table_size')

  return {
    window_size: { width: 0, height: 0 },
    el_resize: '',
    action: '',
    event: null,
    footer_tab: 'solutions',
    fullscreen: false,
    mobile: false,
    hs_open: false,
    table_size: !table_size ? 'small' : table_size,
    drawer: {
      open: false,
      maximized: false,
      item: null,
      // content: {},
      id: '',
    },
    practice_display_mode: 'normal',
    // keydown: null,
    // keydown_dialog: null,
    hsWatcher: true,

    floating_gmf_visible: false,
    // floating_gmf_visible: true,
    floating_bubble_visible: false,
    floating_ec_compare_visible: false,

    // practiceData: null,
    gl_tooltip: null,
    rangebuilder_configure: true,
    maintenanceFilesUpload: false,
    // floating_boxes: [{
    // component: 'GmfSelector',
    // bindings: {},
    // }],
    // floating_boxes:null

    // pressedKeys: '',
    appMessages: [],
    freshChatMessages: 0,
  }
}

const state = getInitialState()

const getters = {
  freshChatMessages: state => state.freshChatMessages,
  appMessages: state => state.appMessages,
  maintenanceFilesUpload: state => state.maintenanceFilesUpload,
  rangebuilder_configure: state => state.rangebuilder_configure,
  floating_gmf_visible: state => state.floating_gmf_visible,
  floating_bubble_visible: state => state.floating_bubble_visible,
  floating_ec_compare_visible: state => state.floating_ec_compare_visible,

  gl_tooltip: state => state.gl_tooltip,
  globals_mobile: state => state.mobile,
  screen_landscape: state => state.window_size.width > state.window_size.height,
  screen_min3440: state => state.window_size.width >= 3440,
  screen_min2650: state => state.window_size.width >= 2650,
  // screen_min2560: state => state.window_size.width >= 2560,
  screen_max1760: state => state.window_size.width <= 1760,
  screen_max1600: state => state.window_size.width <= 1600,
  screen_max1540: state => state.window_size.width <= 1540,
  screen_max1280: state => state.window_size.width <= 1280,
  screen_max1366: state => state.window_size.width <= 1366,
  screen_max768: state => state.window_size.width <= 768,
  screen_max620: state => state.window_size.width <= 620,
  // screen_max520: state => state.window_size.width <= 440,
  screen_max440: state => state.window_size.width <= 440,
  focus_mode: state => state.practice_display_mode === 'focus',
  // globals_keydown: state => state.keydown,

  el_resize: state => state.el_resize,
  globals_action(state) {
    const { action } = state
    return action
  },
  globals_event(state) {
    const { event } = state
    return event
  },
  globals_footer_tab(state) {
    const { footer_tab } = state
    return footer_tab
  },
  globals_fullscreen(state) {
    const { fullscreen } = state
    return fullscreen
  },
  globals_hs_open(state) {
    const { hs_open } = state
    return hs_open
  },
  globals_window_size(state) {
    const { window_size } = state
    return window_size
  },
  globals_drawer: state => state.drawer,
  globals_tips(state) {
    const { tips } = state
    return tips
  },
}

const actions = {
  globals_action_reset({ commit }) {
    commit('globals_action', '')
  },
  globals_action({ commit }, str) {
    commit('globals_action', str)
    // setTimeout(() => {
    //   if (state.action === str) {
    //     commit('globals_action', '')
    //   }
    // }, 1000)
  },
  globals_event({ commit }, obj) {
    commit('globals_event', obj)
  },
  globals_footer_tab({ commit }, str) {
    commit('globals_footer_tab', str)
  },
  globals_drawer_toggle({ dispatch, getters }) {
    if (getters.globals_drawer.id === 'upload-boxes') {
      dispatch('globals_drawer', {
        open: false,
        id: '',
      })
    } else {
      dispatch('globals_drawer', {
        open: true,
        id: 'upload-boxes',
      })
    }
  },
  globals_drawer({ commit, state }, drawer) {
    let open = drawer?.open
    if (open === undefined) open = !state.drawer.open

    let maximized = false
    if (drawer?.toggleMaximized) {
      maximized = !state.drawer.maximized
    }
    if (drawer?.maximized) {
      maximized = true
    }
    commit('globals_drawer', {
      ...drawer,
      ...state.drawer,
      open,
      maximized,
      id: drawer?.id || '',
      item: drawer?.item || null,
      // maximized: true,
      content: drawer?.content || state.drawer.content,
    })
  },
  globals_fullscreen_local({ commit, state }, bool) {
    if (bool === undefined) bool = !state.fullscreen
    localStorage.setItem('hsExpanded', !bool ? 'not-expanded' : 'expanded')
  },
  globals_fullscreen({ commit, state }, bool) {
    if (bool === undefined) bool = !state.fullscreen
    commit('globals_fullscreen', bool)
  },
  globals_focus_mode({ commit, dispatch, state }) {
    if (state.practice_display_mode === 'focus') {
      commit('globals_set', { key: 'practice_display_mode', value: 'normal' })
    } else {
      commit('globals_set', { key: 'practice_display_mode', value: 'focus' })
    }
  },
  globals_hs_open({ commit }, bool) {
    if (bool === undefined) bool = !state.hs_open
    commit('globals_hs_open', bool)
  },
  globals_tips({ commit }, bool) {
    if (bool === undefined) bool = !state.tips
    commit('globals_tips', bool)
  },
  // globals_featureHighlight({ commit }, { id, close = false }) {
  //   if (close) {
  //     commit('globals_set', { key: 'gl_tooltip', value: null })
  //     return
  //   }

  //   const features = {
  //     focus_mode: {
  //       text: 'messages.try_out_focus_mode',
  //     },
  //   }
  //   const value = features[id]
  //   if (!value) {
  //     console.warn('no such feature', { id })
  //     return
  //   }
  //   commit('globals_set', { key: 'gl_tooltip', value })
  // },
}

const mutations = {
  globals_set(state, { key, value }) {
    state[key] = value
  },
  // globals_el_resize(state, str) {
  //   state.el_resize = str
  // },
  globals_action(state, str) {
    state.action = str
  },
  globals_event(state, obj) {
    state.event = obj
  },
  globals_footer_tab(state, str) {
    state.footer_tab = str
  },
  globals_fullscreen(state, bool) {
    state.fullscreen = bool
  },
  globals_mobile(state, bool) {
    state.mobile = bool
  },
  globals_hs_open(state, bool) {
    state.hs_open = bool
  },
  globals_drawer(state, drawer) {
    state.drawer = drawer
  },
  globals_window_size(state, { width, height }) {
    state.window_size = { width, height }
  },
  globals_table_size(state, table_size) {
    state.table_size = table_size
    localStorage.setItem('table_size', table_size)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
